//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QuizQuestionWork from "@/components/quiz/QuizQuestionWork.vue";
import QuizQuestionResultAnswerView from "@/components/quiz/quiz_question_result/QuizQuestionResultAnswerView.vue";
import QuizQuestionResultOptions from "@/components/quiz/quiz_question_result/QuizQuestionResultOptions.vue";
import QuizQuestionResultGridView from "@/components/quiz/quiz_question_result/QuizQuestionResultGridView.vue";

export default {
  name: "QuizQuestionResultItem",
  created() {},
  props: ["result", "index"],
  data() {
    return {};
  },
  methods: {},
  computed: {
    question: function() {
      return this.result.get("baseQuestion");
    }
  },
  components: {
    QuizQuestionWork,
    QuizQuestionResultAnswerView,
    QuizQuestionResultOptions,
    QuizQuestionResultGridView
  }
};



// WEBPACK FOOTER //
// ./src/components/quiz/quiz_question_result/QuizQuestionResultItem.vue